/* NADIRI flavour picker.
   Load state  : NO flavour selected, gallery on the product's first image.
   Click       : selects that flavour, gallery shows its image, accent recolours.
   Click again : deselects, gallery returns to the first image, accent resets.
   Cart always resolves to a real variant (first flavour) even when unselected. */
(function () {
  'use strict';
  function init() {
    var dataEl = document.querySelector('[data-nn-variant-data]');
    var root = document.querySelector('[data-nn-flavour-root]');
    if (!dataEl || !root) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length || !data.flavourOption) return;

    var FL = data.flavourOption, SU = data.supplyOption;
    function optVal(v, n) {
      if (!n || !v.opts) return null;
      for (var i = 0; i < v.opts.length; i++) if (v.opts[i].n === n) return v.opts[i].v;
      return null;
    }

    var supplyValues = [];
    data.variants.forEach(function (v) {
      var s = optVal(v, SU);
      if (s && supplyValues.indexOf(s) === -1) supplyValues.push(s);
    });

    var supplyWrap = document.querySelector('[data-nn-supply]');
    if (supplyWrap && supplyWrap.parentNode) {
      var prev = supplyWrap.previousElementSibling;
      supplyWrap.parentNode.insertBefore(root, (prev && prev.classList.contains('nn-label')) ? prev : supplyWrap);
    }
    root.hidden = false;

    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-nn-flavour]'));
    var firstFlavour = swatches[0] ? swatches[0].dataset.nnFlavour : null;

    swatches.forEach(function (b) {
      var f = b.dataset.nnFlavour;
      var any = data.variants.some(function (v) { return optVal(v, FL) === f && v.available; });
      b.dataset.available = any ? 'true' : 'false';
      if (!any) {
        var s = document.createElement('span');
        s.className = 'nn-flavour__sold'; s.textContent = 'Sold out';
        b.appendChild(s);
      }
    });

    document.querySelectorAll('[data-nn-supply], .nn-supply-pills').forEach(function (g) {
      var b = g.querySelectorAll('[data-nn-opt]');
      for (var i = 0; i < b.length; i++) {
        if (!b[i].dataset.supplyValue && supplyValues[i]) b[i].dataset.supplyValue = supplyValues[i];
      }
    });

    // Remember the page's own accent so deselecting can restore it.
    var cs = getComputedStyle(document.documentElement);
    var baseAccent = {
      a: cs.getPropertyValue('--nn-accent').trim(),
      d: cs.getPropertyValue('--nn-accent-deep').trim(),
      l: cs.getPropertyValue('--nn-accent-light').trim()
    };

    var pinnedId = new URLSearchParams(location.search).get('variant');
    var pinned = pinnedId ? data.variants.filter(function (v) { return String(v.id) === String(pinnedId); })[0] : null;

    // selected === null means "shopper hasn't chosen a flavour yet".
    var selected = pinned ? optVal(pinned, FL) : null;
    var supply = pinned ? optVal(pinned, SU) : supplyValues[0];

    function effectiveFlavour() { return selected || firstFlavour; }

    function findVariant(f, s) {
      return data.variants.filter(function (v) {
        if (optVal(v, FL) !== f) return false;
        if (SU && s) return optVal(v, SU) === s;
        return true;
      })[0] || null;
    }

    function paintAccent(c) {
      var r = document.documentElement.style;
      r.setProperty('--nn-accent', c.a); r.setProperty('--nn-accent-deep', c.d || c.a); r.setProperty('--nn-accent-light', c.l || c.a);
      r.setProperty('--nn-gold', c.a); r.setProperty('--nn-gold-deep', c.d || c.a); r.setProperty('--nn-gold-light', c.l || c.a);
    }

    function showIndex(i) {
      var imgs = document.querySelectorAll('[data-nn-main]');
      if (!imgs.length) return;
      imgs.forEach(function (im, n) { im.style.display = n === i ? '' : 'none'; });
      document.querySelectorAll('[data-nn-thumb]').forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function showMedia(id) {
      if (!id) return;
      var imgs = document.querySelectorAll('[data-nn-main]');
      var f = -1;
      imgs.forEach(function (im, i) { if (String(im.dataset.mediaId) === String(id)) f = i; });
      if (f > -1) showIndex(f);
    }

    function sync(userChose) {
      var f = effectiveFlavour();
      document.querySelectorAll('[data-nn-opt]').forEach(function (btn) {
        var v = findVariant(f, btn.dataset.supplyValue);
        if (!v) return;
        btn.dataset.variantId = v.id;
        btn.dataset.variantPrice = v.priceFmt;
        btn.disabled = !v.available;
        var p = btn.querySelector('.nn-supply__price, .nn-supply-pill__price');
        if (p) p.textContent = v.priceFmt;
        var w = btn.querySelector('.nn-supply__was, .nn-supply-pill__was');
        if (w) { w.textContent = v.compareFmt || ''; w.style.display = v.compareFmt ? '' : 'none'; }
      });

      var sel = findVariant(f, supply) || findVariant(f, null);
      if (!sel) return;
      supply = optVal(sel, SU);

      document.querySelectorAll('[data-nn-variant-input]').forEach(function (i) { i.value = sel.id; });
      document.querySelectorAll('[data-nn-cta-price]').forEach(function (e) { e.textContent = sel.priceFmt; });
      document.querySelectorAll('[data-nn-sticky-name]').forEach(function (e) { e.textContent = sel.title || f; });
      document.querySelectorAll('[data-nn-opt]').forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.variantId) === String(sel.id) ? 'true' : 'false');
      });

      swatches.forEach(function (b) {
        b.setAttribute('aria-checked', selected && b.dataset.nnFlavour === selected ? 'true' : 'false');
      });

      if (userChose) {
        if (selected) { showMedia(sel.mediaId); } else { showIndex(0); }
        document.dispatchEvent(new CustomEvent('nn:variant', {
          detail: { id: sel.id, price: sel.priceFmt, name: sel.title || f }
        }));
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.dataset.nnFlavour;
        if (selected === f) {
          selected = null;              // second click on the same swatch clears it
          paintAccent(baseAccent);
        } else {
          selected = f;
          var a = btn.dataset.accent;
          if (a) paintAccent({ a: a, d: btn.dataset.accentDeep, l: btn.dataset.accentLight });
        }
        sync(true);
      });
    });

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nn-opt]');
      if (b && b.dataset.supplyValue) {
        supply = b.dataset.supplyValue;
        setTimeout(function () { sync(true); }, 0);
      }
    }, true);

    if (pinned && selected) {
      var pb = swatches.filter(function (b) { return b.dataset.nnFlavour === selected; })[0];
      if (pb && pb.dataset.accent) paintAccent({ a: pb.dataset.accent, d: pb.dataset.accentDeep, l: pb.dataset.accentLight });
      sync(true);
    } else {
      sync(false);                     // no swatch lit, gallery untouched on image 1
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
